












































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import headerTip from './header-tip/index.vue';
import * as api from '@/api/business-overview';
import { commaNumber } from '../format';

@Component({
  components: { headerTip }
})
export default class IncomeOverview extends Vue {
  @Prop({ default: 0 })
  type?: Number;

  @Prop({ default: 0 })
  orgIds?: Array<String>;

  @Prop()
  provinceId?: String;

  @Prop()
  parkId?: String;

  @Watch('orgIds')
  @Watch('parkId')
  @Watch('provinceId')
  onOrgChange() {
    this.fetchData();
  }

  // 页面数据
  data: any = {};

  commaNumber: Function = commaNumber;

  mounted() {
    this.fetchData();
  }

  async fetchData() {
    try {
      let param;
      if (this.type == 0) {
        param = {
          provinceId: this.provinceId,
          orgIds: this.orgIds
        };
      } else {
        param = {
          parkId: this.parkId
        };
      }
      const { status, msg, code, data } = await api.queryIncomeOverviewData(param);
      this.data = data;
    } catch (e) {
      console.log(e);
    }
  }
}
